<title mat-dialog-title>{{ createOrEdit }}</title>
<mat-dialog-content>
  <form [formGroup]="form">
    <ng-container *ngIf="loadingFacets">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      {{ 'common.loadingOptions' | t }}...
    </ng-container>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
    <h4 class="notification-time-title">{{ 'map.tools.createSentryDialog.notificationTimeTitle' | t }}</h4>
    <br />
    <ngx-slider
      #timeSlider
      [(value)]="startTime"
      [(highValue)]="endTime"
      [options]="sliderOptions"
      [manualRefresh]="manualRefresh$"
    ></ngx-slider>
    <div class="notifications-container">
      <h3>{{ 'common.notifications' | t }}</h3>
      <sn-icon-button
        color="accent"
        [matTooltip]="'settings.rules.addNotificationUser' | t"
        type="button"
        (click)="addNotification()"
      >
        <sn-icon>add</sn-icon>
      </sn-icon-button>
      <sn-button (click)="setSchedule()">{{ 'map.tools.createSentryDialog.setNotificationSchedule' | t }}</sn-button>
    </div>
    <ng-container
      formArrayName="notificationUsers"
      *ngIf="notificationArray.controls.length; else emptyNotifications"
    >
      <sn-notification-form
        *ngFor="let notificationControl of notificationArray.controls; let rowIndex = index"
        [options]="selectedUsers"
        [formGroupName]="rowIndex"
        [notificationTypes]="['SMS', 'Email']"
        (notificationDeleted)="onNotificationDeleted(rowIndex)"
      >
        {{ rowIndex }}
      </sn-notification-form>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.close' | t }}</button>
  <button
    mat-button
    *ngIf="createMode()"
    color="success"
    (click)="submitForm()"
    [mtBasicSpinner]="isLoading"
    [disabled]="form.invalid"
  >
    {{ 'common.create' | t }}
  </button>
  <button
    mat-button
    color="success"
    (click)="searchThisSentry()"
    [mtBasicSpinner]="isLoading"
    [disabled]="form.invalid"
  >
    {{ 'common.search' | t }}
  </button>
  <button
    mat-button
    *ngIf="!createMode()"
    color="success"
    (click)="updateSentrySearch()"
    [mtBasicSpinner]="isLoading"
    [disabled]="form.invalid"
  >
    {{ 'common.save' | t }}
  </button>
</mat-dialog-actions>
<ng-template #emptyNotifications>
  <div class="empty-notification">{{ 'common.noUsersAdded' | t }}</div>
</ng-template>
